export const LocalStorageKeys = {
  Locale: 'locale',
  Session: 'session',
  ThemeMode: 'theme_mode',
  SelectedGarageByUser: 'selected_garage_by_user'
} as const;

export type LocalStorageKey = (typeof LocalStorageKeys)[keyof typeof LocalStorageKeys];
